import { render, staticRenderFns } from "./Fichier.vue?vue&type=template&id=35200fa9"
import script from "./Fichier.vue?vue&type=script&lang=js"
export * from "./Fichier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports